import React from 'react';
import { connect } from 'react-redux';
import {
    FaHandPeace,
    FaList
} from 'react-icons/fa';
import {
    FiMapPin
} from "react-icons/fi";
import {
    selectViewOption
} from '../../state-management/actions/modal-actions';
import Button from '@material-ui/core/Button';
import { useMediaQuery } from 'react-responsive';
import {
    device
} from '../../style/breakpoints';
import { flexDirection } from '../../style/Global';

// console.log('device', device);

function ViewOptions(props) {
    const {
        viewOptionSelected
    } = props;

    // console.log('viewOptionSelected', viewOptionSelected);

    const isTabletOrMobile = useMediaQuery({ query: device.tablet });

    if (isTabletOrMobile && viewOptionSelected === 'Both'){
        const {
            selectViewOption
        } = props;
        selectViewOption('MapOnly');
    }
    
    // console.log('isTabletOrMobile', isTabletOrMobile);
    const selectViewOption = (view) => {
        const {
            selectViewOption
        } = props;

        selectViewOption(view);
        // console.log('view', view);
    }

    const containerStyle = isTabletOrMobile && viewOptionSelected === 'ListOnly' ? {...flexDirection.column} : {...flexDirection.row}
    return (
        <div
            style={containerStyle}
        >
            {
                !isTabletOrMobile &&
                <div>
                <Button
                    onClick={() => selectViewOption('Both')}
                    style={{
                        backgroundColor: 'Both' === viewOptionSelected ? 'rgb(255, 107, 107)' : '',
                        color: 'Both' === viewOptionSelected ? 'white' : '#9facbd',
                    }}
                    rel="noopener noreferrer"
                >
                    <FaHandPeace
                        color={'Both' === viewOptionSelected ? 'white' : ''}
                    />
                    Both Views
    
                </Button>
                </div>
            }

            <div             
            >
            <Button
                onClick={() => selectViewOption('ListOnly')}
                style={{
                    backgroundColor: 'ListOnly' === viewOptionSelected ? 'rgb(255, 107, 107)' : '',
                    color: 'ListOnly' === viewOptionSelected ? 'white' : '#9facbd',

                }}
                rel="noopener noreferrer"
            >

                <FaList
                    color={'ListOnly' === viewOptionSelected ? 'white' : ''}
                />
                List View

            </Button>
            </div>
            <div>
            <Button
                onClick={() => selectViewOption('MapOnly')}
                style={{
                    backgroundColor: 'MapOnly' === viewOptionSelected ? 'rgb(255, 107, 107)' : '',
                    color: 'MapOnly' === viewOptionSelected ? 'white' : '#9facbd',

                }}
                rel="noopener noreferrer"
            >
                <FiMapPin
                    color={'MapOnly' === viewOptionSelected ? 'white' : ''}


                />
                Map View

            </Button>
            </div>
        </div>
    )

}

const mapDispatchToProps = (dispatch) => {
    return {
        selectViewOption: (viewOption) => dispatch(selectViewOption(viewOption))
    };
};
const mapStateToProps = state => {
    const { modalReducers } = state;
    const {
        viewOptionSelected
    } = modalReducers;
    return {
        viewOptionSelected
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewOptions);